import { combineReducers } from 'redux';
import buttonScrollingModalConfig from '../configs';
import buttonScrollingModalLogos from './buttonScrollingModalLogos';

export default combineReducers({
  config: () => buttonScrollingModalConfig,
  buttonScrollingModalLogos,
});
